import { render, staticRenderFns } from "./ModalAsignarPlacaComponent.vue?vue&type=template&id=399536e3&"
import script from "./ModalAsignarPlacaComponent.vue?vue&type=script&lang=js&"
export * from "./ModalAsignarPlacaComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports